export default {
  noDashboards: 'No dashboards available for {asset}.',
  noWidgets: 'No widgets available for {dashboard}.',
  addDashboard: 'Create dashboard',
  addWidget: 'Add widget',
};
